export default __webpack_public_path__ + "static/media/(Low Res) JD Reception-012.51cc5328.jpg";